export enum ERoutePointType {    
    Loading,
    Unloading
}